export default {"src":"/_next/static/media/Underweight and Malnutrition.08cefac8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};